<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent @change="onYearSelected" />
      </el-col>
      <el-col :span="3">
        <AsignedThecnicians @ThecnicianChaged="onThecnicianChange" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";
import AsignedThecnicians from "@/components/requests/thecnicians/AsignedThecnicians";

export default {
  name: "ReportByProductByMonthFilters",
  components: {
    YearsComponent,
    AsignedThecnicians
  },
  methods: {
    onYearSelected(year) {
      this.$emit("onYearSelected", year);
    },
    onThecnicianChange(thecnicianId) {
      this.$emit("thecnicianChaged", thecnicianId);
    }
  }
};
</script>

<style lang="scss" scoped></style>
